import React from 'react';
import AdminLayout from '../AdminLayout';
import './CampaignStatsPage.css';
import { useGetCampaignStatsQuery } from 'store/services/dripCampaign/dripCampaignApi';
import CampaignStatCard from './components/CampaignStatCard';
import MagicButton from 'components/MagicButton/MagicButton';

const CampaignStatsPage = () => {
  const { data: stats, isLoading, error, refetch } = useGetCampaignStatsQuery();

  // Debug: Log the stats data to see what the backend is returning
  React.useEffect(() => {
    if (stats) {
      console.log('📊 Campaign Stats received:', stats);
      console.log('📊 Stats structure:', JSON.stringify(stats, null, 2));
    }
  }, [stats]);

  return (
    <AdminLayout title="Admin Panel - Drip Campaign Stats" currentPath="/admin/drip-campaign">
      <div className="campaign-stats-page">
        {/* @ts-ignore - AdminLayout children type issue */}
        <div className="campaign-stats-content">
          <div className="stats-header">
            <h1 className="stats-title">Drip Email Campaign Stats</h1>
            <MagicButton
              label="Refresh"
              color="purple"
              onPress={() => refetch()}
              isDisabled={isLoading}
            />
          </div>

          {isLoading && (
            <div className="loading-container">
              <div className="loading-text">Loading campaign stats...</div>
            </div>
          )}

          {error && (
            <div className="error-container">
              <div className="error-text">
                Failed to load campaign stats. Please try again.
              </div>
            </div>
          )}

          {stats?.stats && !isLoading && (
            <div className="stats-grid">
              <CampaignStatCard
                title="Want List Reminder"
                icon="📧"
                stats={stats.stats.WANT_LIST_REMINDER}
              />
              <CampaignStatCard
                title="Email Verification"
                icon="✉️"
                stats={stats.stats.EMAIL_VERIFICATION_REMINDER}
              />
              <CampaignStatCard
                title="Phone Verification"
                icon="📱"
                stats={stats.stats.PHONE_VERIFICATION_REMINDER}
              />
            </div>
          )}

          {stats?.stats && !isLoading && (
            <div className="stats-info">
              <h3>About Drip Campaign Stats</h3>
              <ul>
                <li><strong>Scheduled:</strong> Total number of emails scheduled for this campaign type</li>
                <li><strong>Sent:</strong> Number of emails successfully delivered</li>
                <li><strong>Pending:</strong> Number of emails waiting to be sent (scheduledAt has not passed yet)</li>
                <li>Campaign emails are sent via the existing scheduled message cron job (runs every 15 minutes)</li>
                <li>Users must have <code>emailOnSystemMessage</code> enabled to receive these emails</li>
                <li>Each email is sent only once per user (no duplicates)</li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </AdminLayout>
  );
};

export default CampaignStatsPage;
